<template>
  <RxkDialog width="600" title="节点编辑信息" v-model="show" :showFooter="false">
    <div class="tw-p-[16px] node-edit-info">
      <div class="tw-min-h-[300px]">
        <el-timeline v-if="logsList.length">
          <el-timeline-item
            :hide-timestamp="true"
            v-for="(item, index) in logsList"
            :key="index"
            placement="top"
          >
            <template #dot>
              <div class="edit-info-dot" />
            </template>
            <div class="title tw-flex tw-items-center">
              <span class="text-aaa">{{ item?.createTime }}</span>
              <span class="tw-ml-2 text-333">
                {{ getName(item?.operator, info.userRealNameMap) }}
              </span>
              <span class="tw-ml-2 text-666">编辑</span>
              <span class="tw-ml-2 text-333">{{ item?.tableName }}</span>
            </div>
            <div
              class="tw-flex tw-items-center tw-my-[16px]"
              v-for="(field, i) in item?.content"
              :key="i"
            >
              <template v-if="isNoPaas">
                <span class="tw-ml-2 text-666 tw-flex-shrink-0">
                  {{ field.name }}{{ getName(field.columnSerial, info.columnNameMap) }}
                </span>
                <template v-if="field.oldValue || field.newValue">
                  <span style="margin-left: 10px; color: #666">{{ field.oldValue || '-' }}</span>
                  <span class="tw-ml-2 text-aaa tw-flex-shrink-0">变更为</span>
                  <span class="tw-ml-2 text-666">{{ field.newValue }}</span>
                </template>
                <template v-else>
                  <span>发生变更</span>
                </template>
              </template>
              <template v-else>
                <span class="tw-ml-2 text-666 tw-flex-shrink-0">
                  {{ getName(field.columnSerial, info.columnNameMap) }}
                </span>
                <Render
                  v-if="field.oldValue"
                  style="margin-left: 10px; color: #666"
                  :compName="getRenderConfig(field.columnSerial, item)?.compName"
                  :renderConfig="getRenderConfig(field.columnSerial, item)"
                  :data="getRenderConfig(field.columnSerial, item)"
                  :isTxt="true"
                  :value="field.oldValue"
                />
                <span class="tw-ml-2 text-666" v-else>{{ field.oldValue }}</span>
                <span class="tw-ml-2 text-aaa tw-flex-shrink-0">变更为</span>
                <Render
                  v-if="field.newValue"
                  style="margin-left: 10px; color: #666"
                  :compName="getRenderConfig(field.columnSerial, item)?.compName"
                  :renderConfig="getRenderConfig(field.columnSerial, item)"
                  :data="getRenderConfig(field.columnSerial, item)"
                  :isTxt="true"
                  :value="field.newValue"
                  :modelValue="field.newValue"
                />
                <span class="tw-ml-2 text-666" v-else>{{ field.oldValue }}</span>
              </template>
            </div>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else />
      </div>
      <div class="tw-flex tw-justify-end">
        <RxkButton type="primary" @click="handleClose">知道了</RxkButton>
      </div>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { computed, PropType } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { getName } from '@/components/business/FlowDeal/utils'
// import { getFiled } from '@/apis/flow'
import {
  columnUseSceneEnums,
  dealFormConfig,
  dealFormValConfig,
  useSceneTypeEnums
} from '@/utils/preObjectManage/utils'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import Render from '@/components/custom/form/components/render.vue'
import { getFieldAuth } from '@/components/business/FlowSetting/utils'

const props = defineProps({
  modelValue: Boolean,
  info: {
    type: Object as PropType<{
      modifyDataLogs: any[]
      userRealNameMap: any
      columnNameMap: any
      dataId: string
    }>,
    default: () => ({})
  },
  isNoPaas: Boolean,
  tableCode: String
})

const emits = defineEmits(['update:modelValue'])

const show = computed({
  get: () => {
    return props.modelValue
  },
  set: val => {
    emits('update:modelValue', val)
  }
})

watch(
  () => props.modelValue,
  val => {
    if (val) {
      renderValue()
    }
  },
  { immediate: true }
)

const logs = computed((): any[] => {
  return (
    props.info?.modifyDataLogs?.map((item: any) => {
      let content = JSON.parse(item.content) || []
      return {
        ...item,
        content
      }
    }) || []
  )
})

const logsList = ref<Recordable[]>([])

function handleClose() {
  emits('update:modelValue', false)
}

async function renderValue() {
  try {
    const res = await getFieldAuth(props.tableCode || '')
    logsList.value = logs.value?.map((log: Recordable) => {
      // 修改记录内容循环
      log.content = log.content.map((content: Recordable) => {
        const fieldItem = res.find((e: Recordable) => e.fieldSerial === content?.columnSerial)
        if (fieldItem) {
          content.columnDataList = fieldItem.options
          const strategyFn =
            dealFormConfig[fieldItem.code] || dealFormConfig[fieldTypeConfig.singleLineText]
          const getValueFn = dealFormValConfig[fieldItem.code]
            ? dealFormValConfig[fieldItem.code].getValue
            : undefined
          let oldValue = ''
          try {
            oldValue =
              content.oldValue && getValueFn
                ? getValueFn(fieldItem, {
                    [fieldItem.fieldCode]: content.oldValue
                  })
                : content.oldValue || ''
          } catch (e) {
            oldValue = ''
          }
          let newValue =
            content.newValue && getValueFn
              ? getValueFn(fieldItem, {
                  [fieldItem.fieldCode]: content.newValue
                })
              : content.newValue || ''
          //  标签，历史归属人，资质，跟进记录，这几个字段的回显需要传递的是记录的ID
          if (fieldItem.code === fieldTypeConfig.tags) {
            newValue = [props.info?.dataId]
          }
          return {
            ...content,
            ...fieldItem,
            oldValue: oldValue,
            newValue: newValue,
            renderConfig: {
              ...fieldItem,
              ...strategyFn(fieldItem),
              dataList: fieldItem.options, // 单选多选框反显
              // 人员选择组件需要用到
              columnUseScene: columnUseSceneEnums.processBranch,
              useSceneType: useSceneTypeEnums.paas,
              tableCode: props.tableCode,
              columnInfo: { ...fieldItem }
            }
          }
        }
        return content
      })
      console.log(log.content)
      return log
    })
  } finally {
    console.log('iii')
  }
}

function getRenderConfig(columnSerial: string, item: Recordable) {
  const res = item?.content?.find((el: any) => el.columnSerial === columnSerial)
  return res?.renderConfig || null
}
</script>
<style lang="scss" scoped>
.node-edit-info {
  :deep(.el-timeline-item__dot) {
    top: -5px;
    left: -3px;
  }
  :deep(.el-timeline-item__tail) {
    border-color: #5687ff;
  }
}
.edit-info-dot {
  width: 16px;
  height: 16px;
  background: var(---, #5687ff);
  border: 4px solid #fff;
  border-radius: 8px;
}
.text-aaa {
  color: #aaaaaa;
  font-size: 12px;
}

.text-333 {
  color: #333333;
  font-size: 14px;
}

.text-666 {
  color: #666666;
  font-size: 14px;
  font-style: normal;
}
</style>
